<template>
  <div class="container">
    <el-page-header @back="goBack" content="核销订单" class="header">
    </el-page-header>
    <div class="info-wapper">
      <span class="title">流水信息</span>
      <el-table :data="tableInfo" border style="width: 100%">
        <el-table-column
          prop="tradeNo"
          label="银行流水号"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="flowCode"
          label="序列号"
          width="180"
        ></el-table-column>
        <el-table-column prop="payTime" label="收付时间"> </el-table-column>
        <el-table-column prop="describe" label="摘要"> </el-table-column>
        <el-table-column
          prop="accountName"
          label="客户账户名称"
        ></el-table-column>
        <el-table-column
          prop="contractAccountName"
          label="合约公司账户名称"
        ></el-table-column>
        <el-table-column prop="payName" label="收付款方式"> </el-table-column>
        <el-table-column prop="bankName" label="银行名称"> </el-table-column>
        <el-table-column prop="payAmount" label="收付金额"> </el-table-column>
        <el-table-column prop="verifyRemainTotal" label="待认领金额"> </el-table-column>
      </el-table>
    </div>
    <div class="info-wapper images-wapper">
      <span class="title">核销订单</span>
      <br />
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入订单客户名称"
            v-model.trim="query.customerName"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-select
            placeholder="请选择订单类型"
            v-model="query.orderType"
            style="width:100%;"
          >
            <el-option
              v-for="item in orderTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="请输入订单编号"
            v-model.trim="query.orderNo"
          ></el-input>
        </el-col>

        <el-col :span="6" style="line-height: 40px;">
          <el-button size="small" @click="getvVrificationList">查询</el-button>
        </el-col>
      </el-row>
      <div class="info-wapper"></div>
      <el-table :data="queryOrderList" size="mini" empty-text :border="true">
        <el-table-column
          prop="orderTypeName"
          width="120"
          label="订单类型"
        ></el-table-column>
        <el-table-column prop="orderNo"  width="120" label="订单编号"></el-table-column>
        <el-table-column prop="activationTime" width="120" label="开卡时间"></el-table-column>
        <el-table-column prop="customerName"  width="120" label="客户名称"></el-table-column>
        <el-table-column prop="contractCompanyName" width="120" label="合约公司"></el-table-column>
        <el-table-column
          prop="returnAmount"
          width="120"
          label="预计回款总额"
        ></el-table-column>
        <el-table-column
          prop="refundReturnAmount"
          width="120"
          label="关联退售回款总额"
        ></el-table-column>
        <el-table-column
          prop="totalUsableAmount"
          width="120"
          label="实际应回款总额"
        ></el-table-column>
        <el-table-column prop="usedAmount"  width="120" label="已核销总额"></el-table-column>
        <el-table-column prop="leftAmount"  width="120" label="待核销总额"></el-table-column>
        <el-table-column
          prop="verifyStateName"
          width="100"
          label="核销状态"
        ></el-table-column>
        <el-table-column
          prop="gmtModified"
          label="核销完成时间"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button @click="addUser(scope.row)" type="text" size="small"
            v-if="scope.row.verifyState != 3"
              >添加</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="info-wapper images-wapper">
      <br />

      <el-table
        :data="alreadyOrderList"
        size="mini"
        empty-text
        :border="true"
        :summary-method="getSummaries"
        show-summary
        class="already-table"
      >
        <el-table-column
          prop="orderTypeName"
          width="120"
          label="订单类型"
        ></el-table-column>
        <el-table-column prop="orderNo" width="120" label="订单编号"></el-table-column>
        <el-table-column prop="activationTime" width="120" label="开卡时间"></el-table-column>
        <el-table-column prop="customerName"  width="120" label="客户名称"></el-table-column>
        <el-table-column prop="contractCompanyName"  width="120" label="合约公司"></el-table-column>
        <el-table-column
          prop="returnAmount"
          width="120"
          label="预计回款总额"
        ></el-table-column>
        <el-table-column
          prop="refundReturnAmount"
          width="120"
          label="关联退售回款总额"
        ></el-table-column>
        <el-table-column
          prop="totalUsableAmount"
          width="120"
          label="实际应回款总额"
        ></el-table-column>
        <el-table-column prop="usedAmount"   width="120" label="已核销总额"></el-table-column>
        <el-table-column prop="leftAmount"  width="120" label="待核销总额"></el-table-column>
        <el-table-column
          prop="verifyStateName"
          width="120"
          label="核销状态"
        ></el-table-column>
        <el-table-column prop="verifyAmount" label="本次核销金额" width="120">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.verifyAmount"
              @change="verifyAmountChange($event, scope.$index)"
              oninput="value=value.replace(/^([0-9]\d*\.?\d{0,2})?.*$/,'$1')"

            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="verifyRemainTotal" label="剩余待核销金额" width="120">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.verifyRemainTotal"
              :disabled = 'verifyRemainTotaldis'
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="collectionPeriod"
          label="归属账期"
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button @click="delUser(scope.row,scope.$index)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="bottom-wapper">
      <el-button
        type="primary"
        @click="submit"
        class="el-button"
        :disabled="submitBtn"
        >确认提交</el-button
      >
    </div>
  </div>
</template>
<script>
import _paymentService from "@/service/payment-inquiry-service";
/**

 */
export default {
  data() {
    return {
      query: {
        customerName: "",
        orderType: "",
        orderNo: "",
        contractCompanyName: this.$route.query.contractAccountName,
      },
      queryOrderList: [],
      alreadyOrderList: [],
      submitBtn: true,
      tableInfo: [this.$route.query] || [],
      orderTypeList: null,
      queryCollectionPeriod: {
        flowCode: "",
        payTime: "",
        activationTime:""
      },
      collectionPeriod: "",
      verifyRemainTotaldis: true
    };
  },
  components: {},
  mounted() {
    this.getOrderType();
    // this.getQueryCollection();
  },
  methods: {
    verifyAmountChange(value, index) {

      if (value== "" || value == undefined || value == null) {
        this.$notify({
          message: "请填写本次核销金额",
          type: "warning",
        });
        this.submitBtn = true
        return;
      }else if (value == 0){
        this.$notify({
          message: "不可为0",
          type: "warning",
        });
        this.submitBtn = true
        return;
      }
      else if (Number(value)> Number(this.alreadyOrderList[index].leftAmount)) {
        this.$notify({
          message: "不可大于待核销总额",
          type: "warning",
        });
        this.submitBtn = true
        return;
      }else{
        this.$delete(this.alreadyOrderList[index], 'verifyRemainTotal')

        this.$set( this.alreadyOrderList[index], this.alreadyOrderList[index].verifyRemainTotal = Number(this.alreadyOrderList[index].leftAmount) - Number(value))

        this.submitBtn = false;
      }

    },

    getQueryCollection() {
      this.queryCollectionPeriod.flowCode = this.$route.query.flowCode;
      this.queryCollectionPeriod.payTime = this.$route.query.payTime;
      this.queryCollectionPeriod.activationTime = this.queryOrderList[0].activationTime;
      _paymentService.getQueryCollectionPeriod(
        this.queryCollectionPeriod,
        (res) => {
          this.collectionPeriod = res.collectionPeriod;
        }
      );
    },
    getOrderType() {
      _paymentService.paymentTypeList({ state: "OrderTypeNewEnum" }, (res) => {
        this.orderTypeList = res;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "verifyAmount") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "-";
        }
      });
      return sums;
    },
    submit() {
      this.submitBtn=true
      let orderVerifyList = [];
      var data;
      this.alreadyOrderList.forEach((item) => {

          orderVerifyList.push({
            id: item.id,
            verifyAmount: item.verifyAmount,
            collectionPeriod: item.collectionPeriod,
          });

           data = {
            flowCode: this.$route.query.flowCode,
            systemId: this.$route.query.systemId,
            verifyRemainTotal: this.$route.query.verifyRemainTotal,
            orderVerifyList: orderVerifyList,
          };

      });
      _paymentService.getVerifyCrmOrder(
            data,response => {
              this.submitBtn=false

                this.$notify({
                    message: '成功',
                    type: 'success'
                })

                setTimeout(() => {
                this.$router.go(-1)
                }, 500)


            }, response => {
              this.submitBtn=false
                this.$notify({
                    message: response,
                    type: 'warning'
                })
            })
    },
    formatAmount(value) {
      // 使用正则表达式限制输入为两位小数
      let dat =
        ("" + value) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数

      this.point = dat;
    },

    goBack() {
      this.$router.go(-1);
    },


    getvVrificationList() {
      if (
        !this.query.customerName ||
        !this.query.orderType
      ) {
        this.$notify({
          message: "请输入筛选条件",
          type: "warning",
        });
        return;
      }
      _paymentService.getQueryOrderList(
        this.query,
        (res) => {
          this.queryOrderList = res;
          this.getQueryCollection()
        },
        (err) => {
          this.$notify({
            message: err,
            type: "warning",
          });
        }
      );
    },

    delUser(scope,index) {
      this.alreadyOrderList[index].verifyAmount = ""
      this.alreadyOrderList[index].verifyRemainTotal = ""

      this.alreadyOrderList.splice(index, 1);
      this.submitBtn = true;

    },
    addUser(row) {
      row["collectionPeriod"] = this.collectionPeriod;
      let arry;
      arry = this.alreadyOrderList;
      for (let i = 0; i < arry.length; i++) {
        if (arry[i].orderNo == row.orderNo) {
          this.$notify({
            message: "请勿重复添加",
            type: "warning",
          });
          return;
        }
      }

      this.alreadyOrderList.push(row);

    },
  },
};
</script>
<style scoped>
.title {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 30px 0 10px 0;
}
.container {
  padding: 15px;
}
.info-wapper {
  margin: 15px;
}
.images-wapper {
  border-top: 1px dashed #909399;
  margin-top: 30px;
}
.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
}

.query-wapper::after {
  position: absolute;
  content: "选择员工";
  top: -9px;
  color: #333;
  background-color: #fbfbfb;
}

.query-wapper-second::after {
  position: absolute;
  content: "已选中员工列表";
  top: -9px;
  color: #333;
  background-color: #fbfbfb;
}

.query-wapper-third::after {
  position: absolute;
  content: "积分转移";
  top: -9px;
  color: #333;
  background-color: #fbfbfb;
}
.point-lable /deep/.el-form-item__label::before {
  color: #d9001b;
  content: "*";
}
.button-wapper {
  margin: 10px 0;
}

.bottom-wapper {
  margin: 15px;
  text-align: center;
}

.bottom-wapper .el-button {
  width: 600px;
}

.tips {
  font-size: 10px;
  color: #f59a23;
}
.already-table {
   margin-top: 12px;
}
</style>
